import { toast } from 'react-toastify';

/**
 * Display an error toast notification
 * @param message - The error message to display
 * @param options - Optional toast configuration
 */
// eslint-disable-next-line
export const toastError = (message: string, options?: any) => {
  return toast.error(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  });
};

/**
 * Display a warning toast notification
 * @param message - The warning message to display
 * @param options - Optional toast configuration
 */
// eslint-disable-next-line
export const toastWarning = (message: string, options?: any) => {
  return toast.warning(message, {
    position: 'bottom-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  });
};

/**
 * Display a success toast notification
 * @param message - The success message to display
 * @param options - Optional toast configuration
 */
// eslint-disable-next-line
export const toastSuccess = (message: string, options?: any) => {
  return toast.success(message, {
    position: 'bottom-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    ...options,
  });
};
